import { Injectable } from '@angular/core';
import { NewAlertModel } from './utils/new-alert-model';
import { NewAlertType } from './utils/new-alert-type';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewAlertService {

  private subjectAlerts = new Subject<NewAlertModel>();
  private subjectNotifications = new Subject<NewAlertModel>();

  private defaultId = 'default-alert';

  onAlert(id = this.defaultId): Observable<NewAlertModel> {
    return this.subjectAlerts.asObservable().pipe(filter(x => x && x.id === id));
  }

  onNotification(id = this.defaultId): Observable<NewAlertModel> {
    return this.subjectNotifications.asObservable().pipe(filter(x => x && x.id === id));
  }




  success(message: string, options?: any) {
    this.alert(new NewAlertModel({ ...options, type: NewAlertType.Success, message }));
  }

  error(message: string, options?: any) {
    this.alert(new NewAlertModel({ ...options, type: NewAlertType.Error, message }));
  }

  info(message: string, options?: any) {
    this.alert(new NewAlertModel({ ...options, type: NewAlertType.Info, message }));
  }

  warning(message: string, options?: any) {
    this.alert(new NewAlertModel({ ...options, type: NewAlertType.Warning, message }));
  }



 
  notificationSuccess(title: string, message: string, options?: any) {
    this.notification(new NewAlertModel({ ...options, type: NewAlertType.Success, message, title }));
  }

  notificationError(title: string, message: string, options?: any) {
    this.notification(new NewAlertModel({ ...options, type: NewAlertType.Error, message, title }));
  }

  notificationInfo(title: string, message: string, options?: any) {
    this.notification(new NewAlertModel({ ...options, type: NewAlertType.Info, message, title }));
  }

  notificationWarning(title: string, message: string, options?: any) {
    this.notification(new NewAlertModel({ ...options, type: NewAlertType.Warning, message, title }));
  }




  private alert(alert: NewAlertModel) {
    alert.id = alert.id || this.defaultId;
    this.subjectAlerts.next(alert);
  }

  private notification(notification: NewAlertModel) {
    notification.id = notification.id || this.defaultId;
    this.subjectNotifications.next(notification);
  }




  clear(id = this.defaultId) {
    this.subjectAlerts.next(new NewAlertModel({ id }));
  }

  clearNotifications(id = this.defaultId) {
    this.subjectNotifications.next(new NewAlertModel({ id }));
  }
}
